"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _styles = require("@ori-ui/mui-bundle/material/styles");
var styleOverrides = {
    rail: {
        height: 4,
        borderRadius: 2
    },
    track: {
        height: 4,
        borderRadius: 2
    },
    mark: {
        height: 4
    },
    thumb: function(param) {
        var theme = param.theme;
        var _obj;
        return _obj = {
            width: 28,
            height: 28,
            backgroundColor: theme.palette.common.white,
            boxShadow: theme.shadows[2]
        }, _define_property(_obj, "&:hover, &.".concat(_material.sliderClasses.focusVisible), {
            boxShadow: theme.shadows[3],
            '@media (hover: none)': {
                boxShadow: 'none'
            }
        }), _define_property(_obj, "&.".concat(_material.sliderClasses.active), {
            boxShadow: theme.shadows[3]
        }), _define_property(_obj, "&.".concat(_material.sliderClasses.disabled), {
            width: 28,
            height: 28,
            backgroundColor: 'currentColor',
            boxShadow: 'none',
            '&:hover': {
                boxShadow: 'none'
            }
        }), _obj;
    },
    thumbColorPrimary: function(param) {
        var theme = param.theme;
        var _obj;
        return _obj = {}, _define_property(_obj, "&:hover, &.".concat(_material.sliderClasses.focusVisible), {
            boxShadow: theme.shadows[3],
            '@media (hover: none)': {
                boxShadow: 'none'
            }
        }), _define_property(_obj, "&.".concat(_material.sliderClasses.focusVisible), {
            boxShadow: "".concat(theme.shadows[3], ", 0px 0px 0px 8px ").concat((0, _styles.alpha)(theme.palette.primary.main, 0.17))
        }), _define_property(_obj, "&.".concat(_material.sliderClasses.active), {
            boxShadow: theme.shadows[4]
        }), _obj;
    },
    thumbColorSecondary: function(param) {
        var theme = param.theme;
        var _obj;
        return _obj = {}, _define_property(_obj, "&:hover, &.".concat(_material.sliderClasses.focusVisible), {
            boxShadow: theme.shadows[3],
            '@media (hover: none)': {
                boxShadow: 'none'
            }
        }), _define_property(_obj, "&.".concat(_material.sliderClasses.focusVisible), {
            boxShadow: "".concat(theme.shadows[3], ", 0px 0px 0px 8px ").concat((0, _styles.alpha)(theme.palette.secondary.main, 0.17))
        }), _define_property(_obj, "&.".concat(_material.sliderClasses.active), {
            boxShadow: theme.shadows[4]
        }), _obj;
    }
};
var defaultProps = {
    color: 'primary'
};
var _default = exports.default = {
    styleOverrides: styleOverrides,
    defaultProps: defaultProps
}; //# sourceMappingURL=MuiSlider.js.map
